import { Card } from "../ui/Card.jsx";
import { IconTile } from "../ui/IconTile.jsx";
import { SectionHeading } from "../ui/SectionHeading.jsx";
import { Icon } from "../ui/Icon.jsx";
import { INDUSTRIES } from "./HeroMock.jsx";

export function Problem({ activeIndustry }) {
  const active = INDUSTRIES[activeIndustry];
  const items = [
    { icon: <Icon.Search />, title: "Your next best customers are out there. Your tools can't identify them." },
    { icon: <Icon.Database />, title: "Every system holds a piece of the customer. None of them has the whole picture." },
    { icon: <Icon.Chat />, title: "The first sale is where most relationships stop." },
  ];

  return (
    <section className="section" id="problem">
      <div className="container">
        <SectionHeading
          eyebrow="The problem"
          title="The big players don't just outspend you. They know their customers better."
        />
        <div className="grid-3">
          {items.map((it, i) => (
            <Card key={i} className="info-card" data-reveal>
              <IconTile icon={it.icon} />
              <h3>{it.title}</h3>
              <p>{active.problemBodies[i]}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
